// 全局应用上下文：档案、激活档案、主题
import { createContext, useContext } from 'react'
import type { BirthProfile } from './lib/bazi'

export type ThemeMode = 'light' | 'dark' | 'system'

export interface AppContextValue {
  profiles: BirthProfile[]
  activeProfile: BirthProfile | null
  setActiveProfile: (id: string) => void
  saveProfile: (p: BirthProfile) => void
  deleteProfile: (id: string) => void
  theme: ThemeMode
  setTheme: (t: ThemeMode) => void
}

export const AppCtx = createContext<AppContextValue>({
  profiles: [],
  activeProfile: null,
  setActiveProfile: () => {},
  saveProfile: () => {},
  deleteProfile: () => {},
  theme: 'system',
  setTheme: () => {},
})

export function useApp() {
  return useContext(AppCtx)
}